export default __webpack_public_path__ + "static/media/app-store.9f631ca8.png";